"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightedText = exports.highlightedTextStyles = void 0;
var react_1 = __importDefault(require("react"));
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var shared_1 = require("../shared");
var css_1 = require("@emotion/css");
var highlightedTextStyles = function (selectedTheme) { return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), (0, design_system_foundations_1.expandFontTheme)((0, design_system_foundations_1.addFontThemePrefix)(selectedTheme, 'bodyStrong'))); };
exports.highlightedTextStyles = highlightedTextStyles;
var HighlightedText = function (_a) {
    var itemValue = _a.itemValue, inputText = _a.inputText, testId = _a.testId;
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var locale = (0, design_system_foundations_1.useLocalizationContext)().locale;
    var collator = new Intl.Collator(locale, { sensitivity: 'base' });
    var itemValueSplits = itemValue.split(new RegExp("(".concat((0, shared_1.escapeString)(inputText), ")"), 'i'));
    return (react_1.default.createElement(react_1.default.Fragment, null, itemValueSplits.map(function (itemValueSplit, index) { return (react_1.default.createElement("span", { key: "".concat(itemValueSplit, "-").concat(index), className: collator.compare(itemValueSplit, inputText) === 0 ? (0, exports.highlightedTextStyles)(selectedTheme) : '', "data-testid": testId && "".concat(testId, "-highlighted-text-").concat(itemValueSplit) }, itemValueSplit)); })));
};
exports.HighlightedText = HighlightedText;
var templateObject_1;
